<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="mb-2">
            <h3>วัตถุดิบคงเหลือปัจจุบัน</h3>
        </div>
        <div class="d-flex justify-space-between mb-2">
            <div class="half_stock_report_list mr-1">
                <v-card class="pa-3 mb-2">
                    <div class="d-flex justify-space-between align-center">
                        <div>
                            <div>
                                มูลค่าวัตถุดิบ
                            </div>
                            <div>
                                คงเหลือ
                            </div>
                        </div>
                        <div>
                            {{ Intl.NumberFormat().format(current_balance_material_total) }} บาท
                        </div>
                    </div>
                </v-card>
                <div>
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        ประเภท
                                    </th>
                                    <th class="text-left">
                                        มูลค่า
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(current_balance_material_detail,index) in current_balance_material" :key="index">
                                    <td class="text-left">{{ current_balance_material_detail.name }}</td>
                                    <td class="text-left">{{ Intl.NumberFormat().format(current_balance_material_detail.price) }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>

            </div>
            <div class="half_stock_report_list ml-1">
                <div>
                    <canvas id="my-chart-first"></canvas>
                </div>
            </div>
        </div>

        <hr>
        <div class="mt-4 mb-2">
            <h3>วัตถุดิบเข้า-ออก</h3>
            <div class="font_subtitle_stock_report_list">
                สามารถดูรายงานวัตถุดิบเข้า-ออกย้อนหลังได้ โดยเลือกวันที่เริ่มต้นและวันที่สิ้นสุด
            </div>
        </div>
        <div class="d-flex justify-space-between align-center mb-2">
            <div class="startdate_stock_report_list mr-1">
                <v-menu ref="menu_start_date" v-model="menu_start_date" :close-on-content-click="false" :return-value.sync="start_date" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="start_date_be" label="วันที่เริ่ม (วัน/เดือน/ปี)" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="start_date" :max="end_date" no-title scrollable locale="th" :events="dateStartEndBE('start_date')">
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="searchDate('start_date')">
                            ตกลง
                        </v-btn>
                        <v-btn text color="primary" @click="menu_start_date = false">
                            ยกเลิก
                        </v-btn>
                    </v-date-picker>
                </v-menu>
            </div>

            <div class="enddate_stock_report_list ml-1">
                <v-menu ref="menu_end_date" v-model="menu_end_date" :close-on-content-click="false" :return-value.sync="end_date" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="end_date_be" label="วันที่สิ้นสุด (วัน/เดือน/ปี)" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="end_date" :min="start_date" no-title scrollable locale="th" :events="dateStartEndBE('end_date')">
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="searchDate('end_date')">
                            ตกลง
                        </v-btn>
                        <v-btn text color="primary" @click="menu_end_date = false">
                            ยกเลิก
                        </v-btn>
                    </v-date-picker>
                </v-menu>
            </div>
        </div>

        <div class="d-flex justify-space-between mb-2">
            <div class="half_stock_report_list mr-1">
                <v-card class="pa-3 mb-2">
                    <div class="d-flex justify-space-between align-center">
                        <div>
                            มูลค่ารวม (เข้า)
                        </div>
                        <div>
                            {{ Intl.NumberFormat().format(total_price_in) }} บาท
                        </div>
                    </div>
                </v-card>
                <div class="mb-2">
                    <canvas id="my-chart-in"></canvas>
                </div>
                <div>
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        ประเภท
                                    </th>
                                    <th class="text-left">
                                        มูลค่า
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(price_in_detail,index) in price_in_list" :key="index">
                                    <td class="text-left">{{ price_in_detail.name }}</td>
                                    <td class="text-left">{{ Intl.NumberFormat().format(price_in_detail.price) }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>
            </div>
            <div class="half_stock_report_list ml-1">
                <v-card class="pa-3 mb-2">
                    <div class="d-flex justify-space-between align-center">
                        <div>
                            มูลค่ารวม (ออก)
                        </div>
                        <div>
                            {{ Intl.NumberFormat().format(total_price_out) }} บาท
                        </div>
                    </div>
                </v-card>
                <div class="mb-2">
                    <canvas id="my-chart-out"></canvas>
                </div>
                <div class="d-flex justify-center mb-2">
                    <div class="half_stock_report_list mr-1">
                        <v-card class="pa-3">
                            <div>
                                ที่ใช้
                            </div>
                            <div class="text-right">
                                {{ Intl.NumberFormat().format(use_price_out) }} บาท
                            </div>
                        </v-card>
                    </div>
                    <div class="half_stock_report_list ml-1">
                        <v-card class="pa-3">
                            <div>
                                ทิ้ง
                            </div>
                            <div class="text-right">
                                {{ Intl.NumberFormat().format(lose_price) }} บาท
                            </div>
                        </v-card>
                    </div>
                </div>
                <div>
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        รายการ
                                    </th>
                                    <th class="text-left">
                                        ที่ใช้
                                    </th>
                                    <th class="text-left">
                                        ทิ้ง
                                    </th>
                                    <th class="text-left">
                                        รวม
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(price_out_detail,index) in price_out_list" :key="index">
                                    <td class="text-left">{{ price_out_detail.name }}</td>
                                    <td class="text-left">{{ price_out_detail.use_price }}</td>
                                    <td class="text-left">{{ price_out_detail.lose_price }}</td>
                                    <td class="text-left">{{ price_out_detail.use_price + price_out_detail.lose_price }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>
            </div>
        </div>

    </div>
</div>
</template>

<script>
import stockreport from '@/api/stock/stocklist/stockreport.js'
import Chart from 'chart.js'
// import 'chartjs-plugin-labels'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            current_balance_material_total: 0,
            current_balance_material: [],
            menu_start_date: false,
            menu_end_date: false,
            start_date_be: '',
            start_date: '',
            end_date_be: '',
            end_date: '',
            total_price_in: 0,
            total_price_out: 0,
            price_in_list: [],
            price_out_list: [],
            use_price_out: 0,
            lose_price: 0,
        }
    },
    methods: {
        dateStartEndBE(type) {
            if (type == 'start_date') {
                if (this.start_date == '') {
                    this.start_date_be = ''
                }
                if (this.start_date) {
                    let date_arr = this.start_date.split('-')
                    let year = parseInt(date_arr[0]) + 543
                    let month = parseInt(date_arr[1]) - 1
                    month = this.$store.state.monthList[month].name_short
                    this.start_date_be = `${date_arr[2]}/${month}/${year}`
                }
            }
            if (type == 'end_date') {
                if (this.end_date == '') {
                    this.end_date_be = ''
                }
                if (this.end_date) {
                    let date_arr = this.end_date.split('-')
                    let year = parseInt(date_arr[0]) + 543
                    let month = parseInt(date_arr[1]) - 1
                    month = this.$store.state.monthList[month].name_short
                    this.end_date_be = `${date_arr[2]}/${month}/${year}`
                }
            }
        },
        async searchDate(type) {
            if (type == 'start_date') {
                this.$refs.menu_start_date.save(this.start_date)
                let date_arr = this.start_date.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.start_date_be = `${date_arr[2]}/${month}/${year}`
                this.menu_start_date = false
            }
            if (type == 'end_date') {
                this.$refs.menu_end_date.save(this.end_date)
                let date_arr = this.end_date.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.end_date_be = `${date_arr[2]}/${month}/${year}`
                this.menu_end_date = false
            }
            if (this.start_date && this.end_date) {
                this.chartAll()
            }
        },
        async chartAll() {
            this.loading_page = true
            await stockreport.stockMaterialReportList().then((response) => {
                if (response.data.successful === true) {
                    this.current_balance_material_total = response.data.detail.total_price
                    this.current_balance_material = response.data.detail.list

                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

            await stockreport.stockMaterialInOutReportList(this.start_date, this.end_date).then((response) => {
                if (response.data.successful === true) {
                    this.total_price_in = response.data.total_price_in
                    this.total_price_out = response.data.total_price_out
                    this.price_in_list = response.data.typeIn
                    this.price_out_list = response.data.typeOut
                    this.use_price_out = response.data.use_price_out
                    this.lose_price = response.data.lose_price_out
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

            let ctx_first = document.getElementById('my-chart-first')
            new Chart(ctx_first, {
                type: 'pie',
                data: {
                    labels: this.current_balance_material.map((detail) => {
                        return detail.name
                    }),
                    datasets: [{
                        data: this.current_balance_material.map((detail) => {
                            return detail.price
                        }),
                        backgroundColor: this.current_balance_material.map((detail) => {
                            return detail.color
                        })
                    }]
                },
                options: {
                    legend: {
                        display: false
                    },
                    responsive: true,
                    maintainAspectRatio: true,
                    plugins: {
                        labels: {
                            render: 'value',
                            fontColor: this.current_balance_material.map(() => {
                                return '#000000'
                            }),
                            precision: 2
                        }
                    },
                }
            })

            let ctx_in = document.getElementById('my-chart-in')
            new Chart(ctx_in, {
                type: 'pie',
                data: {
                    labels: this.price_in_list.map((detail) => {
                        return detail.name
                    }),
                    datasets: [{
                        data: this.price_in_list.map((detail) => {
                            return detail.price
                        }),
                        backgroundColor: this.price_in_list.map((detail) => {
                            return detail.color
                        })
                    }]
                },
                options: {
                    legend: {
                        display: false
                    },
                    responsive: true,
                    maintainAspectRatio: true,
                    plugins: {
                        labels: {
                            render: 'value',
                            fontColor: this.price_in_list.map(() => {
                                return '#000000'
                            }),
                            precision: 2
                        }
                    },
                }
            })

            let ctx_out = document.getElementById('my-chart-out')
            const use_price_all = this.price_out_list.map((detail) => {
                return detail.use_price
            })
            const lose_price_all = this.price_out_list.map((detail) => {
                return detail.lose_price
            })
            const all_price = use_price_all.concat(lose_price_all)
            new Chart(ctx_out, {
                type: 'bar',
                data: {
                    labels: this.price_out_list.map((detail) => {
                        return detail.name
                    }),
                    datasets: [{
                            data: this.price_out_list.map((detail) => {
                                return detail.use_price
                            }),
                            backgroundColor: this.price_out_list.map(() => {
                                return '#4CAF50'
                            }),
                        },
                        {
                            data: this.price_out_list.map((detail) => {
                                return detail.lose_price
                            }),

                            backgroundColor: this.price_out_list.map(() => {
                                return '#FF5252'
                            }),
                        },
                    ]
                },
                options: {
                    legend: {
                        display: false
                    },
                    responsive: true,
                    maintainAspectRatio: true,
                    plugins: {
                        labels: {
                            render: 'value',
                            fontColor: this.price_out_list.map(() => {
                                return '#000000'
                            }),
                            precision: 2
                        }
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                max: Math.max(...all_price) + 1000,
                                beginAtZero: true
                            }
                        }]
                    },
                }
            })
        }
    },
    created() {
        this.chartAll()
    }
}
</script>

<style scoped>
.startdate_stock_report_list,
.enddate_stock_report_list {
    width: 50%;
}

.half_stock_report_list {
    width: 50%;
}

.font_subtitle_stock_report_list {
    font-size: 17px;
    color: #565656;
}

canvas {
    width: 100%;
}
</style>
